<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                         <el-input
                            size="small"
                            style="width:180px;"
                            placeholder="请输入姓名 / 手机 / QQ"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-date-picker
                        @change="query"
                        :clearable="false"
                        size="small" 
                        style="width:220px;margin-left:10px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select
                        style="margin-left:10px;width:150px"
                        size="small"
                            v-model="queryModel.shopId"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入店铺名称"
                            :remote-method="remoteMethod"
                            :loading="shopLoading">
                                <el-option
                                v-for="item in shopList"
                                :key="item.Key"
                                :label="item.Value"
                                :value="item.Key">
                                </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:10px;width:100px"  filterable   v-model="queryModel.managerId" clearable placeholder="审核人">
                            <el-option v-for="v in managerList" :key="v.Id" :label="v.RealName" :value="v.Id"> </el-option>
                        </el-select>
                        <el-switch
                        style="margin-left:10px"
                        @change="query"
                        v-model="queryModel.isPay"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="已打款"
                        inactive-text="未打款">
                        </el-switch>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:20px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:10px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button type="primary" size="small" style="margin-left:10px;" @click="daochu" icon="el-icon-download" plain circle></el-button>
                        </el-tooltip>
                        <b style="font-size:13px;margin-left:20px">总计：</b>
                        <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{moneyTotal.toFixed(2)}}</el-tag>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                        width="100px"
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                        width="70px"
                            prop="Name"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                            prop="ShopName"
                            label="店铺名称">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            width="130"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                        width="130"
                            prop="QQ"
                            label="QQ">
                        </el-table-column>
                        <el-table-column
                        width="150"
                            prop="BankAccountName"
                            label="开户行">
                        </el-table-column>
                        <el-table-column
                        width="200"
                            label="银行卡号">
                            <template slot-scope="scope">
                                <el-link @click="copy(scope.row)" icon="el-icon-copy-document" type="primary">{{scope.row.BankCardNo}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="OrderTime"
                            label="接单时间">
                        </el-table-column>
                        <el-table-column
                            prop="PayTime"
                            label="打款时间">
                        </el-table-column>
                        <el-table-column
                            prop="ManageName"
                            label="发起人">
                        </el-table-column>
                        <el-table-column
                        width="100"
                            label="本金金额">
                            <template slot-scope="scope">
                                <el-tag class="tag_btn" size="mini" v-if="scope.row.PayStatus==1" type="info" effect="dark">￥{{scope.row.AdvanceMoney}}</el-tag>
                                <el-tag class="tag_btn" size="mini" v-else-if="scope.row.PayStatus==2" type="danger" effect="dark">￥{{scope.row.AdvanceMoney}}</el-tag>
                                 <el-tag class="tag_btn" size="mini" v-else type="success" effect="dark">￥{{scope.row.AdvanceMoney}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="180"
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" v-if="scope.row.PayStatus==2" effect="dark" content="已打款给该用户" placement="bottom">
                                    <el-button size="mini"  @click="pay(scope.row)" >已打款</el-button>
                                </el-tooltip>
                                <el-button size="mini" type="danger" v-if="scope.row.PayStatus==2"   @click="canelPay(scope.row)" >取消打款</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { orderCancelPayOrder,managerGetSel,shopQuery, orderGetPayOrder,orderPayOrder,uri} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {
    props:{
      manger:{
        type:Object,
        required: true
      }
    },
    data(){
        return {
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                isPay:false,
                createTimes:[],
                shopId:"",
                managerId:"",
            },
            tableData:[],
            shopLoading:false,
            shopList:[],
            moneyTotal:0,
            managerList:[],
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        
    },
    mounted(){
        managerGetSel({},(res)=>{
            this.managerList=res.Result;
        });
        var date=new Date();
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.query();
    },
    methods: {
        canelPay(scope){
            this.$confirm('确认取消打款吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                orderCancelPayOrder({orderId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.PayStatus=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        daochu(){
           window.open(uri+"/Order/GetPayOrderExl?isPay="+this.queryModel.isPay+"&managerId="+(this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId))+"&queryTxt="+this.queryModel.queryTxt
           +"&shopId="+(this.queryModel.shopId==""?0:parseInt(this.queryModel.shopId))+"&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes))
           );
        },
        remoteMethod(query) {
            if (query !== '') {
                this.shopLoading = true;
                shopQuery({queryTxt:query},(res)=>{
                    this.shopLoading = false;
                    this.shopList=res.Result;
                });
            } else {
                this.shopList = [];
            }
        },
        copy(scope){
            this.$copyText(scope.BankCardNo).then(function () {
            }, function (e) {
                console.log(e);
            })
        },
        pay(scope){
            this.$confirm('确认已打款金额 ￥'+scope.AdvanceMoney+' 给用户了吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                orderPayOrder({orderId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.PayStatus=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
            orderGetPayOrder({
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                queryTxt:this.queryModel.queryTxt,
                isPay:this.queryModel.isPay,
                shopId:this.queryModel.shopId==""?0:this.queryModel.shopId,
                managerId:this.queryModel.managerId==""?0:this.queryModel.managerId,
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(arr),
            },(res)=>{
                this.tableData=res.Result.List;
                this.moneyTotal=res.Result.Total;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                isPay:false,
                createTimes:[],
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },

    }
}
</script>
